import { Component, Input, ViewChild, ElementRef, OnChanges, Output, EventEmitter } from '@angular/core';
import { MatDatepicker } from '@angular/material/datepicker';
import { MatDatePickerConfig } from './matdatepicker.model';
import { Validators, UntypedFormControl } from '@angular/forms';
import moment from 'moment';
import { AppConstants } from '../constants/app-constants';

@Component({
  selector: 'anms-mat-date-picker',
  templateUrl: './matdatepicker.component.html',
  styleUrls: ['./matdatepicker.component.scss'],
  standalone: false
})


export class MatDatePickerComponent implements OnChanges {

  @Input() config: MatDatePickerConfig = new MatDatePickerConfig();
  @Input() date: Date | null = null;
  @Input() isRequired = false;
  @Output() dateInput = new EventEmitter();
  @Output() dateChange = new EventEmitter();
  @Input() disabled!: boolean;


  @ViewChild('formControl', { read: ElementRef }) field!: ElementRef;
  @ViewChild('datepickerFooter', { static: false }) datepickerFooter!: ElementRef;
  @ViewChild('datepicker', { static: false }) datepicker!: MatDatepicker<any>;
  public dateControl = new UntypedFormControl();

  createForm() {
    this.dateControl.patchValue(this.date);
  }

  inputEvent(event: any) {
    // event.value is a moment object
    this.date = event.value;
    this.updateDateForm();
    this.dateInput.emit(event.value.format(AppConstants.DATE_FORMATS.parse.dbSaveFormat));
  }

  changeEvent(event: any) {
    // event.value is a moment object
    this.date = event.value;
    this.updateDateForm();
    this.dateChange.emit(event.value.format(AppConstants.DATE_FORMATS.parse.dbSaveFormat));
  }

  ngOnChanges() {
    if (this.config) {
      this.config.startView = this.config.startView ? this.config.startView : 'month';
      this.config.dateFilterError = this.config.dateFilterError ? this.config.dateFilterError : 'Invalid Date';
    }

    this.createForm();
  }

  setValidators() {
    if (this.isRequired) {
      this.dateControl.setValidators([Validators.required]);
    } else {
      this.dateControl.setValidators(null);
    }
  }

  onOpen() {
    if (!this.config.removeTodaysIcon) {
    this.appendFooter();
    }
  }

  today() {
    this.date = new Date();
    this.updateDateForm();
    this.dateInput.emit(moment(this.date).format(AppConstants.DATE_FORMATS.parse.dbSaveFormat));
    this.datepicker.close();
  }

  openDatePicker() {
    this.datepicker.open();
  }

  updateDateForm() {
    this.dateControl.patchValue(this.date);
  }

  clearDate() {
    this.date = null;
    this.updateDateForm();
    this.dateInput.emit(this.date);
  }

  appendFooter() {    
      const matCalendar = document.getElementsByClassName('mat-datepicker-content')[0] as HTMLElement;
      matCalendar.appendChild(this.datepickerFooter.nativeElement); 
  }
}
